import React from 'react';

const Footer = () => {
  return (
    <footer className=" text-white text-center p-5" style={{backgroundColor:'#080D27'}}>
      <div className="max-w-screen-lg mx-auto">
        <p className="mb-3">© 2024 WALL-E. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
